export const SIN_ESTADO = 'SIN'
export const PENDIENTE_ENVIO = 'PEN_ENV'
export const ENVIADO = 'ENV'
